import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 0993FCF5-5C89-4F54-ABFC-310CDF2AED15
 * name human-non-binary
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-non-binary.svg
 * tags
 * - People / Family 
 */
export const HumanNonBinaryIcon = createSvgIcon(<><path d="M12 2C13.11 2 14 2.9 14 4S13.11 6 12 6 10 5.11 10 4 10.9 2 12 2M13.91 8.41C13.66 7.59 12.9 7 12 7H10.5C9.4 7 8.5 7.9 8.5 9V14.5H10V22H13.5V16H16.5L13.91 8.41Z" /></>, 'HumanNonBinaryIcon');
export default HumanNonBinaryIcon